import { JetView } from 'webix-jet';
import { countries, devConfig, profile } from 'config/config';

/**
 * Class representing the FilterPromotionalCodesView.
 * @extends JetView
 */
export default class FilterPromotionalCodesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const left = {
            margin: 5,
            id: 'a9',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'text',
                            minWidth: 200,
                            name: 'UserId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                        },
                        {
                            view: 'text',
                            minWidth: 200,
                            name: 'BetId',
                            type: 'text',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Apuesta'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID de la apuesta'),
                        },
                        {
                            view: 'richselect',
                            name: 'CampaignType',
                            minWidth: 200,
                            required: true, // Field is required
                            label: "<span class='icon-state'></span>" + _('Tipo campaña:'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                {
                                    id: '0',
                                    value: _('Bono'),
                                },
                                {
                                    id: '1',
                                    value: _('Torneo'),
                                },
                                {
                                    id: '2',
                                    value: _('Sorteo'),
                                },
                            ],
                        },
                        {
                            view: 'text',
                            minWidth: 200,
                            name: 'CampaignId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Campaña'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID de la campaña'),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a4',
                    cols: [
                        {
                            view: 'text',
                            minWidth: 200,
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'), // Default date range
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 3 },
                        {
                            view: 'button',
                            value: _('Ingresar apuesta'),
                            type: 'form',
                            hidden: !devConfig.getPermAction('addPromotionalCasino', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-addPromotionalCasino',
                            click: () => {
                                this.app.callEvent('addBet:button', [{}]); // Event to add a bet
                            },
                        },
                        {
                            view: 'button',
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clears the form
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'),
                            hotkey: 'enter', // Shortcut key for the button
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            id: 'consultDesk',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (filterdata['CampaignType'] != '') {
                                    this.app.callEvent(
                                        'balanceAdjustments:filter',
                                        [filterdata], // Trigger filter event with form data
                                    );
                                    $$('b5').collapse(); // Collapse the filter section
                                } else {
                                    webix.message({
                                        title: _('Complete los campos'),
                                        type: 'alert-error',
                                        text: _('* Tipo campaña es requerido'), // Error message for required field
                                    });
                                }
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500 ? accordion_section2 : { height: 1, width: 0 }, // Conditional rendering based on screen size
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang();
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
